import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import url from "../../function/url";
import CompanyNavbar from "./CompanyNavbar";
import Cookies from "js-cookie";
const ViewEmployees = () => {
  const [employees, setEmployees] = useState([]);
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filters, setFilters] = useState({
    department: "",
    passOutYears: "",
    qualification: "",
  });
  const [options, setOptions] = useState({
    department: [],
    years: [],
    qualifications: [],
  });
  const [filterDropdown, setFilterDropdown] = useState(false);
  const [nextPage, setNextPage] = useState(null);
  const [prevPage, setPrevPage] = useState(null);
  const [noResultsFound, setNoResultsFound] = useState(false);
  const logId = Cookies.get("log_id");

  const fetchEmployees = useCallback(
    (urlPath = `${url.path}/employeesCompany/`) => {
      axios
        .get(urlPath, {
          params: { log_id: logId },
        })
        .then((response) => {
          console.log(response.data);
          setEmployees(response.data.results || []);
          setFilteredEmployees(response.data.results || []);
          setNextPage(response.data.next);
          setPrevPage(response.data.previous);
        })
        .catch((error) => {
          console.error("Error fetching employees:", error);
        });
    },
    [logId]
  );
  useEffect(() => {
    fetchEmployees();

    axios
      .get(`${url.path}/filter_optionscompany/`, { params: { log_id: logId } })
      .then((response) => {
        console.log(response.data);
        setOptions({
          department: response.data.department || [],
          qualifications: response.data.qualifications || [],
          years: generateYears(),
        });
      })
      .catch((error) => {
        console.error("Error fetching filter options:", error);
      });
  }, [fetchEmployees]);

  const generateYears = () => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let i = 0; i < 50; i++) {
      years.push(currentYear - i);
    }
    return years;
  };

  const handleFilterChange = (event) => {
    setFilters({ ...filters, [event.target.name]: event.target.value });
  };

  const applyFilters = () => {
    const { department, passOutYears, qualification } = filters;
    let queryParams = {};

    if (department) queryParams.department = department;
    if (passOutYears) queryParams.passout_year = passOutYears;
    if (qualification) queryParams.qualification = qualification;

    axios
      .get(`${url.path}/filter_optionscompany/`, {
        params: { ...queryParams, log_id: logId },
      })

      .then((response) => {
        setFilteredEmployees(response.data.employees);
        setNoResultsFound(response.data.employees.length === 0);
        setFilterDropdown(false);
      })
      .catch((error) => {
        console.error("Error applying filters:", error);
      });
  };

  const resetFilters = () => {
    setFilters({
      department: "",
      passOutYears: "",
      qualification: "",
    });

    setFilteredEmployees(employees);
    setNoResultsFound(false);
    setFilterDropdown(false);
  };

  const handleSearch = (event) => {
    const searchValue = event.target.value.toLowerCase();
    setSearchTerm(searchValue);

    const filtered = employees.filter((emp) =>
      emp.Employee_Name.toLowerCase().includes(searchValue)
    );

    setFilteredEmployees(filtered);
    setNoResultsFound(filtered.length === 0);
  };

  const handleNextPage = () => {
    if (nextPage) {
      fetchEmployees(nextPage);
    }
  };

  const handlePrevPage = () => {
    if (prevPage) {
      fetchEmployees(prevPage);
    }
  };

  return (
    <>
      <CompanyNavbar />
      <center>
        <h3 style={{ fontSize: "20px", position: "relative", top: "10px" }}>
          View Company
        </h3>
      </center>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginBottom: "10px",
        }}
      >
        <input
          type="text"
          value={searchTerm}
          onChange={handleSearch}
          placeholder="Search by name, email, or contact..."
          className="search-input"
          style={{
            width: "250px",
            padding: "8px",
            borderRadius: "5px",
            border: "1px solid #ccc",
            textAlign: "center",
          }}
        />
      </div>

      <div className="relative flex justify-end px-4">
        <button
          onClick={() => setFilterDropdown(!filterDropdown)}
          className="px-4 py-2 bg-teal-600 text-white rounded-md hover:bg-teal-700 transition"
        >
          Filters
        </button>

        {filterDropdown && (
          <div className="absolute right-3 mt-11 w-64 bg-white border border-gray-300 rounded-md shadow-lg z-20">
            <div className="p-4">
              <label className="block mb-2 font-semibold">Department</label>
              <select
                name="department"
                value={filters.department}
                onChange={handleFilterChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-teal-500"
              >
                <option value="">Select Department</option>
                {options.department.map((department) => (
                  <option key={department} value={department}>
                    {department}
                  </option>
                ))}
              </select>

              <label className="block mt-4 mb-2 font-semibold">
                Pass Out Year
              </label>
              <select
                name="passOutYears"
                value={filters.passOutYears}
                onChange={handleFilterChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-teal-500"
              >
                <option value="">Select Year</option>
                {options.years.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>

              <label className="block mt-4 mb-2 font-semibold">
                Qualification
              </label>
              <select
                name="qualification"
                value={filters.qualification}
                onChange={handleFilterChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-teal-500"
              >
                <option value="">Select Qualification</option>
                {options.qualifications.map((qualification) => (
                  <option key={qualification} value={qualification}>
                    {qualification}
                  </option>
                ))}
              </select>

              <button
                onClick={applyFilters}
                className="w-full mt-4 px-4 py-2 bg-teal-600 text-white rounded-md hover:bg-teal-700 transition"
              >
                Apply Filters
              </button>

              <button
                onClick={resetFilters}
                className="w-full mt-2 px-4 py-2 bg-gray-400 text-white rounded-md hover:bg-gray-500 transition"
              >
                Reset
              </button>
            </div>
          </div>
        )}
      </div>

      <div className="rounded-md mt-4">
        {noResultsFound ? (
          <div className="text-center py-6 text-gray-600">
            No employees found.
          </div>
        ) : (
          <div className="table-container">
            <table className="responsive-table" id="productstable">
              <thead className="bg-black">
                <tr className="bg-indigo-600 text-black">
                  <th className="px-4 py-2">Employee Name</th>
                  <th className="px-4 py-2">Email</th>
                  <th className="px-4 py-2">Contact Number</th>
                  <th className="px-4 py-2">Role</th>
                  <th className="px-4 py-2">Department</th>
                </tr>
              </thead>
              <tbody>
                {filteredEmployees.map((employee) => (
                  <tr key={employee.id} className="hover:bg-teal-50">
                    <td className="px-4 py-2">{employee.Employee_Name}</td>
                    <td className="px-4 py-2">{employee.Email}</td>
                    <td className="px-4 py-2">{employee.Contact_number}</td>
                    <td className="px-4 py-2">{employee.Role}</td>
                    <td className="px-4 py-2">{employee.Department}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="flex justify-between mt-4">
              <button
                onClick={handlePrevPage}
                disabled={!prevPage}
                className={`px-4 py-2 rounded-md ${
                  prevPage
                    ? "bg-teal-600 text-white hover:bg-teal-700"
                    : "bg-gray-300 text-gray-500 cursor-not-allowed"
                }`}
              >
                Previous
              </button>

              <button
                onClick={handleNextPage}
                disabled={!nextPage}
                className={`px-4 py-2 rounded-md ${
                  nextPage
                    ? "bg-teal-600 text-white hover:bg-teal-700"
                    : "bg-gray-300 text-gray-500 cursor-not-allowed"
                }`}
              >
                Next
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
export default ViewEmployees;
